import React from "react";

const AuthFetch = () => <div></div>;

const BASE_URL =
    process.env.REACT_APP_API_URL;

// 🔐 Refresh access token using refresh cookie (HttpOnly)
export const refreshAuthToken =
    async () => {
        try {
            const response =
                await fetch(
                    `${BASE_URL}/subscription/api/auth/refresh`,
                    {
                        method:
                            "POST",

                        credentials:
                            "include", // 🔥 Must include cookie
                    }
                );

            if (!response.ok) {
                console.error(
                    "❌ Refresh token request failed:",
                    response.status
                );

                return null;
            }

            const data =
                await response.json();

            console.log(
                "🔄 New token received:",
                data.token
            );

            if (data.token) {
                localStorage.setItem(
                    "authToken",
                    data.token
                );

                return data.token;
            }

            return null;

        } catch (error) {
            console.error(
                "❌ Refresh token failed:",
                error
            );

            return null;
        }
    };

// 🚀 Secure fetch wrapper with Auto-Token-Refresh handling
export const fetchWithAuth =
    async (
        url,
        options = {}
    ) => {
        let token =
            localStorage.getItem(
                "authToken"
            );

        const updatedOptions = {
            ...options,

            headers: {
                ...options.headers,

                Authorization:
                    `Bearer ${token}`,
            },

            credentials:
                "include",
        };

        let response =
            await fetch(
                url,
                updatedOptions
            );

        // 🔥 Token Expired → Auto Refresh
        if (
            response.status ===
            401 ||
            response.status === 403
        ) {
            console.warn(
                "⚠ Token expired → Attempting refresh..."
            );

            const newToken =
                await refreshAuthToken();

            if (!newToken) {
                alert(
                    "❌ Session ended! Please login again."
                );

                localStorage.clear();

                window.location.href =
                    "/";

                return null;
            }

            updatedOptions.headers.Authorization =
                `Bearer ${newToken}`;

            // Retry original request
            response =
                await fetch(
                    url,
                    updatedOptions
                );
        }

        return response;
    };

export default AuthFetch;